// extracted by mini-css-extract-plugin
export default {"modal-info-tip":"styles_modal-info-tip__5VSII","modal-info-tip-title":"styles_modal-info-tip-title__mc8Il","modal-side-tip-close":"styles_modal-side-tip-close__5oKEE"};